var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradientFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 316,
    viewBox: "0 0 328 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1132_11301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-138.298 286.459C-218.18 324.279 -54.8997 495.571 53.9043 402.548L183.328 187.495L299.588 143.075L486.119 115.039L414.594 44.75L312.336 -72.1545L225.039 -160.33C251.7 -131.292 197.908 12.2431 105.949 119.412C34.8048 202.325 -63.4128 251.004 -138.298 286.459Z",
    fill: "url(#paint0_diamond_1132_11301)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1132_11301",
    x: -259.551,
    y: -260.33,
    width: 845.67,
    height: 790.198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1132_11301"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_1132_11301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.859 177.175) rotate(49.4709) scale(189.48 317.243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E359EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientFooter);
export default __webpack_public_path__ + "static/media/gradient_footer.3165ca7d8578418ca648c46a9329db41.svg";
export { ForwardRef as ReactComponent };